<!--
  Multi R/W Navigation Guard Confirm Dialog
  TAMS Multi R/W 상태 네비게이션 컨펌 다이얼로그

  @since 2019-04-12
  @author mk.ko
-->

<template>
  <!-- Multi RW PopUp -->
  <confirm-dialog ref="confirmDialog"
                  class="modal-content-warning"
                  :footerBtnList="currentPath === '' ? confirmMultirwBtnList : confirmNotBtnList"
                  :noEscDismiss="true"
                  :noBackdropDismiss="true"
                  @onCancelmove="cancelMove"
                  @onApplymove="applyMove"
  >
    <div class="contents-row row items-center no-wrap">
      <span class="ps-icon ps-icon-dialog-02"></span>

      <div class="contents-row">
        <template v-if="message.length > 0">
          <p v-for="msg in message" :key="msg">{{msg}}</p>
        </template>
        <template v-else>
          <p>{{ $t('cmn.msg_thisPageChanged') }}</p>
          <p v-if="currentPath === 'backupRestore'">{{ $t('cmn.msg_continueOrApply2') }}</p>
          <p v-else>{{ $t('cmn.msg_continueOrApply') }}</p>
        </template>
      </div>
    </div>
  </confirm-dialog>
</template>

<script>
  import { bus } from '~/utils/multirw'

  import { createNamespacedHelpers } from 'vuex'
  const multirwHelpers = createNamespacedHelpers('common/multirw')

  export default {
    name: 'MultiRWGuardConfirmDialog',
    props: {},
    components: {},
    directives: {},
    mixins: [],
    data () {
      return {
        self: this,
        path: '',
        name: '',
        params: void 0,
        confirmMultirwBtnList: [
          {text: this.$t('cmn.close'), color: 'dark', type: 'no'},
          {text: this.$t('cmn.cancelMove'), color: 'primary', type: 'cancelmove'},
          {text: this.$t('cmn.applyMove'), color: 'primary', type: 'applymove'}
        ],
        confirmNotBtnList: [
          {text: this.$t('cmn.close'), color: 'dark', type: 'no'},
          {text: this.$t('cmn.checkoutMove'), color: 'primary', type: 'cancelmove'}
        ],
        intervalCnt: 0,
        waitingTimer: void 0,
        guardType: void 0, // next: callback 수행, 이외: 페이지 이동
        message: [],
        currentPath: ''
      }
    },
    computed: {
      ...multirwHelpers.mapGetters([
        'isMultiRWGuard'
      ]),
      ...multirwHelpers.mapState([
        'thisMenuPath'
      ])
    },
    methods: {
      ...multirwHelpers.mapMutations([
        'setPreventPageMoveReload'
      ]),
      cancelMove () {
        if (this.isMultiRWGuard) {
          this.setPreventPageMoveReload(true)
          bus.$emit('footer-cancel')
        }

        if (this.guardType === 'next') {
          bus.$emit('guard-confirm', true)
        } else {
          this.waitingPageMove()
        }
      },
      applyMove () {
        if (this.isMultiRWGuard) {
          this.setPreventPageMoveReload(true)
          bus.$emit('footer-apply')
        }

        if (this.guardType === 'next') {
          bus.$emit('guard-confirm', true)
        } else {
          this.waitingPageMove()
        }
      },
      waitingPageMove () {
        if (this.isMultiRWGuard) {
          // 최대 30초간 Waiting 이후 페이지 이동 작업 없을 경우 릴리즈
          if (this.intervalCnt > 30) {
            clearTimeout(this.waitingTimer)
            this.intervalCnt = 0
            // this.$log('### Waiting...Stop!!!', this.intervalCnt)
          } else {
            const self = this.self
            this.waitingTimer = setTimeout(() => {
              self.waitingPageMove()
              self.intervalCnt++
              // this.$log('### Waiting...', this.intervalCnt)
            }, 1000)
          }
        } else {
          this.intervalCnt = 0
          if (!_.isEmpty(this.params)) {
            this.$router.push({
              name: this.name,
              params: this.params
            })
          } else {
            this.$router.push(this.path)
          }
          this.path = ''
          this.name = ''
          this.params = void 0
        }
      },
      show ({ path, name = '', params, type, message } = {}) {
        const arrSplit = this.thisMenuPath.split('/')
        if (arrSplit[arrSplit.length - 1] === 'backupRestore') {
          this.currentPath = arrSplit[arrSplit.length - 1]
        } else {
          this.currentPath = ''
        }
        this.path = path
        this.name = name
        this.params = params
        this.message = []

        try {
          const replaceMsg = message.replace(/\r\n/g, '\n'),
            splitMessage = replaceMsg.split('\n')
          this.message = splitMessage
        } catch (e) {
          if (typeof message !== 'undefined') {
            this.message.push(message)
          }
        }

        // 페이지 이동 / 콜백 구분
        this.guardType = type

        this.$refs.confirmDialog.show()
      }
    },
    mounted () {
      bus.$on('guard-show', this.show)
    },
    beforeDestroy () {
      bus.$off('guard-show', this.show)

      // 셀프 객체 초기화
      this.self = null
    },
    watch: {}
  }
</script>

<style scoped>
</style>
